export let MENU_ITEM = [
  {
    path: 'index',
    title: 'Tableau de bord',
    icon: 'bar-chart',
    roles : ['*']
  },
  {
    path: 'achat/etats',
    icon: 'bar-chart',
    title: 'Etats',
    roles : ['ADMIN', 'SUPER_ADMIN'],
  },
  {
    path: 'achat',
    title: 'Achat',
    icon: 'cart-plus',
    roles : ['ADMIN', 'AGENT_CENTRE', 'CHEF_LABORATOIRE'],
    children: [
      {
        path: 'bonreception',
        title: 'Bon réception',
        roles : ['ADMIN', 'AGENT_CENTRE', 'CHEF_LABORATOIRE'],
      }, {
        path: 'demandeanalyse',
        title: 'Demande d\'analyse',
        roles : ['ADMIN', 'AGENT_CENTRE', 'CHEF_LABORATOIRE'],
      },
      {
        path: 'bordereaudemandeanalyse',
        title: 'Bordereaux d\'envoie',
        roles : ['ADMIN', 'AGENT_CENTRE', 'CHEF_LABORATOIRE'],
      },
      {
        path: 'etat-bonreception',
        title: 'Etat de réception',
        roles : ['ADMIN', 'AGENT_CENTRE', 'CHEF_LABORATOIRE'],
      }
    ]
  },
  {
    path: 'vente',
    title: 'Stock',
    icon: 'usd',
    roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL', 'AGENT_CENTRE'],
    children: [
      {
        path: 'stock',
        title: 'Etat du stock',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL', 'AGENT_CENTRE'],
      }
    ]
  },
  {
    path: 'labo',
    title: 'Laboratoire',
    icon: 'flask',
    roles : ['ADMIN', 'LABORATOIRE_SAISIE', 'CHEF_LABORATOIRE'],
    children: [
      {
        path: 'ficheanalyse',
        title: 'Bullettin d\'analyse',
        roles : ['ADMIN', 'LABORATOIRE_SAISIE', 'CHEF_LABORATOIRE'],
      },
      {
        path: 'bordereauanalyse',
        title: 'Bordereaux d\'analyse',
        roles : ['ADMIN', 'LABORATOIRE_SAISIE', 'CHEF_LABORATOIRE'],
      },
      {
        path: 'dashboard',
        title: 'Tableau de bord',
        roles : ['ADMIN', 'LABORATOIRE_SAISIE', 'CHEF_LABORATOIRE'],
      }
    ]
  },
  {
    path: 'vente',
    title: 'Paiement',
    icon: 'credit-card',
    roles : ['ADMIN', 'RESPONSABLE_PAIEMENT'],
    children: [
      {
        path: 'bulletin-paie/list/CREATED',
        title: 'Saisie de BP',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT'],
      },
      {
        path: 'bulletin-paie/list/PRE_VALIDATED',
        title: 'Bullettin de paie',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT'],
      },
      {
        path: 'bordereaux',
        title: 'Bordereaux paie',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT'],
      },
      {
        path: 'credit',
        title: 'Credits',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT'],
      },
      {
        path: 'bap',
        title: 'BAP',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT'],
      }
    ]
  },
  {
    path: 'vente',
    title: 'Vente',
    icon: 'usd',
    roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL', 'AGENT_CENTRE'],
    children: [
      {
        path: 'boncommande',
        title: 'Bon de Commande',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL'],
      },
      {
        path: 'bontransfert',
        title: 'Bon de Transfert',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL', 'AGENT_CENTRE'],
      },
      {
        path: 'bonlivraison',
        title: 'Bon Livraison',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL', 'AGENT_CENTRE'],
      },
      {
        path: 'etat-bon-commande',
        title: 'Etat bon de commande',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL', 'AGENT_CENTRE'],
      }
    ]
  },
  {
    path: 'vente',
    title: 'Facturation',
    icon: 'usd',
    roles : ['ADMIN'],
    children: [
      {
        path: 'facture_acompte',
        title: 'Facture Acompte',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL', 'AGENT_CENTRE'],
      },
      {
        path: 'facture_reliquat',
        title: 'Facture Reliquat',
        roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL', 'AGENT_CENTRE'],
      }
    ]
  },
  {
    path: 'achat',
    title: 'Agriculteurs',
    icon: 'sliders',
    roles : ['AGENT_CENTRE'],
    children: [
      {
        path: 'farmers',
        title: 'List des agriculteurs',
        roles : ['AGENT_CENTRE'],
      }
    ]
  },
  {
    path: 'achat',
    title: 'Paramètres',
    icon: 'sliders',
    roles : ['ADMIN', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL'],
    children: [
      {
        path: 'centres',
        title: 'Centres',
        roles : ['ADMIN', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL']
      },
      {
        path: 'farmers',
        title: 'Agriculteurs',
        roles : ['ADMIN', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL'],
      },
      {
        path: 'products',
        title: 'Produits',
        roles : ['ADMIN', 'CHEF_COMMERCIAL' , 'SIMPLE_COMMERCIAL'],
      }
    ]
  },
  {
    path: 'admin',
    title: 'Gestion utilisateurs',
    icon: 'cogs',
    roles : ['ADMIN']
  }
];
